import { ListItem, ListItemText } from '@mui/material'

export const SecondaryInformationListItem: React.FC<{
    primary: React.ReactNode
    secondary?: React.ReactNode
}> = ({ primary, secondary }) => (
    <ListItem
        sx={theme => ({
            borderLeftWidth: 1,
            borderLeftStyle: 'solid',
            borderLeftColor: theme.vars.palette.divider,
        })}
    >
        <ListItemText
            primary={primary}
            secondary={secondary}
            slotProps={{ primary: { color: 'textSecondary' } }}
        />
    </ListItem>
)
